import "core-js/modules/es.array.concat.js";
import { LOGIN, ROUTES } from '@/services/api';
import { request, METHOD, removeAuthorization } from '@/utils/request';
var BASE_URL = process.env.VUE_APP_API_BASE_URL;

/** 更新基础设置信息（#262）
 * @param {Object} data
 */
export function updateBasicInfo(data) {
  return request("".concat(BASE_URL) + "/systemSetting/basicInfo", METHOD.PUT, data);
}

/** 获取基础设置信息数据（#261）
 */
export function getSystemSetting() {
  return request("".concat(BASE_URL) + "/systemSetting", METHOD.GET);
}

/** 更新积分设置信息（#269）
 * @param {Object} data
 */
export function updatePointSetting(data) {
  return request("".concat(BASE_URL) + "/systemSetting/pointSetting", METHOD.PUT, data);
}

/**
 * 查询支付方式列表数据（#263）
 */
export function getpaymentList() {
  return request("".concat(BASE_URL) + "/systemSetting/payment/list", METHOD.GET);
}

/** 查询支付方式列表数据_下拉使用（#120）
 * @param {Object} data
 */
export function getPaymentDropdownList(data) {
  return request("".concat(BASE_URL) + "/systemSetting/payment/dropdown/list/" + data, METHOD.GET);
}

/**获取支付方式信息数据（#265）
 * @param {Object} id
 */
export function getpaymentDetail(id) {
  return request("".concat(BASE_URL) + "/systemSetting/payment/" + id, METHOD.GET);
}

/** 更新支付方式信息（#266）
 * @param {Object} data
 */
export function updatePayment(data) {
  return request("".concat(BASE_URL) + "/systemSetting/payment", METHOD.PUT, data);
}

/** 更新支付方式列表排序信息（#328）
 * @param {Object} data
 */
export function updatePaymentListSort(data) {
  return request("".concat(BASE_URL) + "/systemSetting/payment/list/sort", METHOD.PUT, data);
}

/** 更新支付方式的状态（#264）
 * @param {Object} data
 */
export function updatePaymentStatus(data) {
  return request("".concat(BASE_URL) + "/systemSetting/payment/status", METHOD.PUT, data);
}

/**
 * 查询运输公司列表数据（#270）
 */
export function getTransportationCompanyList() {
  return request("".concat(BASE_URL) + "/systemSetting/avaliableTransportationCompany/list", METHOD.GET);
}

/**
 *获取系统支持的运输公司的id及name数据列表（#271）弹窗下拉使用
 */
export function getTransportationCompanySupportList() {
  return request("".concat(BASE_URL) + "/systemSetting/transportationCompanySupport/list", METHOD.GET);
}

/** 新增有效运输公司数据（#272）
 * @param {Object} data
 */
export function addTransportationCompany(data) {
  return request("".concat(BASE_URL) + "/systemSetting/avaliableTransportationCompany", METHOD.POST, data);
}

/** 编辑运输公司显示名称数据（#274）
 * @param {Object} data
 */
export function updateTransportationCompanyShowName(data) {
  return request("".concat(BASE_URL) + "/systemSetting/avaliableTransportationCompany/showName", METHOD.PUT, data);
}

/**获取运输公司信息数据（#273）
 * @param {Object} id
 */
export function getTransportationCompanyDetail(id) {
  return request("".concat(BASE_URL) + "/systemSetting/avaliableTransportationCompany/" + id, METHOD.GET);
}

/** 更改运输公司状态（#9994）
 * @param {Object} data
 */
export function updateTransportationCompany(id, transportationStatus) {
  return request("".concat(BASE_URL) + "/systemSetting/avaliableTransportationCompany/".concat(id, "/status/").concat(transportationStatus), METHOD.PUT);
}

/** 更新SEO设置信息（#277）
 * @param {Object} data
 */
export function updateSeo(data) {
  return request("".concat(BASE_URL) + "/systemSetting/SEO", METHOD.PUT, data);
}

/** 更新邮件设置信息（#279）
 * @param {Object} data
 */
export function updateEmailSetting(data) {
  return request("".concat(BASE_URL) + "/systemSetting/emailSetting", METHOD.PUT, data);
}

/** 更新其他设置信息（#289）
 * @param {Object} data
 */
export function updateOtherSetting(data) {
  return request("".concat(BASE_URL) + "/systemSetting/otherSetting", METHOD.PUT, data);
}

/**
 * 获取客户联系客服数据列表（#283）
 */
export function getCustomerServiceList() {
  return request("".concat(BASE_URL) + "/systemSetting/customerService/list", METHOD.GET);
}

/**
 * 获取用户协议数据列表（#280）
 */
export function getAgreementSetting() {
  return request("".concat(BASE_URL) + "/systemSetting/agreement", METHOD.GET);
}

/** 编辑用户协议数据（#282）
 * @param {Object} data
 */
export function updateAgreementSetting(data) {
  return request("".concat(BASE_URL) + "/systemSetting/agreement", METHOD.PUT, data);
}

/** 获取评论赠送积分数据列表（#1111）
 * @param {Object}
 */
export function getEvaluatePointList() {
  return request("".concat(BASE_URL) + "/systemSetting/evaluatePoint/list", METHOD.GET);
}

/** 新增联系客服数据（#286）
 * @param {Object} data
 */
export function addCustomerService(data) {
  return request("".concat(BASE_URL) + "/systemSetting/customerService", METHOD.POST, data);
}

/**获取客户联系客服信息数据（#285）
 * @param {Object} data
 */
export function getCustomerService(id) {
  return request("".concat(BASE_URL) + "/systemSetting/customerService/" + id, METHOD.GET);
}

/** 编辑联系客服数据（#287）
 * @param {Object} data
 */
export function editCustomerService(data) {
  return request("".concat(BASE_URL) + "/systemSetting/customerService", METHOD.PUT, data);
}

/** 删除联系客服信息数据（#9995）
 * @param {Object} id
 */
export function deleteCustomerService(id) {
  return request("".concat(BASE_URL) + "/systemSetting/customerService/" + id, METHOD.DELETE);
}

// 部署设置页面接口

// 获取部署设置的信息
export function getDeployData() {
  return request("".concat(BASE_URL) + "/yy/setting/others/deployment/detail", METHOD.GET);
}

// 编辑部署设置的信息
export function saveDeployData(data) {
  return request("".concat(BASE_URL) + "/yy/setting/others/deployment/detail", METHOD.PUT, data);
}

//同步商品到 elastic
export function syncElastic(data) {
  return request("".concat(BASE_URL) + "/yy/setting/others/deployment/productEsindex", METHOD.POST, data, {
    headers: {
      'Content-Type': "application/x-www-form-urlencoded"
    }
  });
}

//社会化登录开启关闭
// export function socialLoginIsopen(status){
//   return request(`${BASE_URL}/yy/social/platform/status/${status}` , METHOD.PUT)
// }

//社会化登录列表
export function socialLoginData() {
  return request("".concat(BASE_URL) + "/yy/social/platform/list", METHOD.GET);
}

//修改社会化登录显示顺序
export function changeSocialLoginList(data) {
  return request("".concat(BASE_URL) + "/yy/social/platform/changeShowOrder", METHOD.PUT, data);
}
//停用启用社会化/邮件通知
export function socialLoginNotifyIsopen(data) {
  return request("".concat(BASE_URL) + "/yy/notification/config", METHOD.PUT, data);
}
// 停用启用社会化登录配置
export function socialLoginIsopen(id, status) {
  return request("".concat(BASE_URL) + "/yy/social/platform/".concat(id, "/status/").concat(status), METHOD.PUT);
}
// 社会化配置编辑接口
export function editSocialLogin(id, data) {
  return request("".concat(BASE_URL) + "/yy/social/platform/".concat(id), METHOD.PUT, data);
}
//通知类型预览
export function notifyPreview(data) {
  return request("".concat(BASE_URL) + "/yy/notification/view", METHOD.GET, data);
}
//查询社会化/邮件通知列表
export function queryNotifyList(nfWay) {
  return request("".concat(BASE_URL, "/yy/notification/config/list?nfWay=").concat(nfWay), METHOD.GET);
}

/**获取接口报错列表 **/
export function getApiErrorData() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request("".concat(BASE_URL) + "/yy/setting/others/errorMail/list", METHOD.GET, data);
}
/** 将报错的接口标记为已解决 **/
export function resolveError() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request("".concat(BASE_URL) + "/yy/setting/others/errorMailBatch", METHOD.PUT, data);
}

// 邮件通知接口
// 获取邮件签名
export function getEmailSignature() {
  return request("".concat(BASE_URL) + "/yy/setting/others/email/signature", METHOD.GET);
}
// 新增或者编辑邮件签名
export function editEmailSignature(data) {
  return request("".concat(BASE_URL) + "/yy/setting/others/email/signature/addOrUpdate", METHOD.PUT, data);
}
// 商品图片水印接口

//获取水印设置
export function getWaterMarking() {
  return request("".concat(BASE_URL) + "/yy/setting/others/watermark/detail", METHOD.GET);
}

// 编辑水印设置
export function editWatermarking(data) {
  return request("".concat(BASE_URL) + "/yy/setting/others/watermark", METHOD.PUT, data);
}

// 获取水印预览图
export function getPreviewImg(data) {
  return request("".concat(BASE_URL) + "/common/upload", METHOD.POST, data);
}

//获取下单完成页面
export function getPagesettingData() {
  return request("".concat(BASE_URL) + '/yy/setting/others/getOrderCompleteContent', METHOD.GET);
}

// 新增/编辑/删除 下单完成页面
export function updatePagesetting(data) {
  return request("".concat(BASE_URL) + "/yy/setting/others/saveOrderCompleteContent", METHOD.POST, data);
}

// 更新catalog页面
export function updateCatalogsetting(data) {
  return request("".concat(BASE_URL) + "/systemSetting/saveCatalogUrl", METHOD.PUT, data);
}

// 更新联系我们页面
export function updateContactsetting(oldEmail, newEmail, type) {
  return request("".concat(BASE_URL) + "/systemSetting/saveContactUsEmail?oldEmail=" + oldEmail + '&newEmail=' + newEmail + '&type=' + type, METHOD.PUT);
}

/** 删除联系我门
 */
export function deleteContactUs(email) {
  return request("".concat(BASE_URL) + "/systemSetting/delContactUsEmail?email=" + email, METHOD.DELETE);
}

//新增联系我们邮箱
export function addContactUsEmail(data) {
  return request("".concat(BASE_URL) + "/systemSetting/addContactUsEmail?email=" + data, METHOD.POST);
}

// 更新担当者群邮箱
export function updateSellerEmail(sellerEmail) {
  return request("".concat(BASE_URL) + "/systemSetting/saveSellerEmail?sellerEmail=" + sellerEmail, METHOD.PUT);
}

// 同步得意先60天卖上传票
export function sync60Erp() {
  return request("".concat(BASE_URL) + "/erporder/syncErpOrderForDays", METHOD.POST);
}
export function getAppUpgradeData(data) {
  return request("".concat(BASE_URL) + "/yy/setting/others/getSettingOtherByType", METHOD.GET, data);
}
export function saveAppUpgradeData(data) {
  return request("".concat(BASE_URL) + "/yy/setting/others/updateSettingOtherByType", METHOD.PUT, data);
}
export function getSettingOtherData(data) {
  return request("".concat(BASE_URL) + "/yy/setting/others/getSettingOtherByType", METHOD.GET, data);
}
export function saveSettingOtherData(data) {
  return request("".concat(BASE_URL) + "/yy/setting/others/updateSettingOtherByType", METHOD.PUT, data);
}